import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { ReactComponent as ArrowNext } from "../../assets/icons/arrowNext.svg";
import { ReactComponent as PathfinderLogoLeftCorner } from "../../assets/images/Pathifnder Logo_White.svg";
import loginBackground from "../../assets/images/login-background.png";
import { Auth } from "../../routes/Constants";
import APIVariables from "../../services/api-variables";
import axios from "axios";

import { validatePassword } from "../../shared/helpers";
import CheckRegister from "../../assets/icons/checkRegister.svg";
import Error from "../../assets/icons/warning-red.svg";
import { errorMessages } from "../../constants/errorMessages.constants";

const shellClass =
  "relative isolate flex min-h-screen min-h-dvh flex-col bg-[#0d5c52] bg-cover bg-center bg-fixed bg-no-repeat font-sans";
const cardClass =
  "login-z w-full max-w-[520px] rounded-[2.75rem] border border-white/30 bg-white/18 px-8 py-10 shadow-[0_8px_40px_rgba(0,0,0,0.18)] backdrop-blur-[22px] sm:px-12";
const cardStyle = { WebkitBackdropFilter: "blur(22px)" };
const labelClass = "ml-2 text-sm font-semibold text-white";
const inputClass =
  "w-full rounded-lg border-0 bg-white px-4 py-2 text-[15px] text-[#374151] shadow-inner outline-none ring-2 ring-transparent placeholder:text-gray-400 focus:ring-2 focus:ring-white/70 disabled:cursor-not-allowed disabled:opacity-70";
const primaryButtonClass =
  "inline-flex h-[46px] min-w-[160px] cursor-pointer items-center justify-center rounded-full border-0 bg-[#00567a] px-6 text-lg font-bold text-white hover:bg-[#005eb8] disabled:bg-[#8c8c8c]";
const greenButtonClass =
  "mt-5 inline-flex h-[46px] min-w-[160px] cursor-pointer items-center justify-center rounded-full border-0 bg-[#00a03b] px-6 text-lg font-bold text-white hover:bg-[#008a32]";

const ResetPassword = () => {
  const navigate = useNavigate();
  const { token, uid } = useParams();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [loginCredentials, setLoginCredentials] = useState({
    email: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [message, setMessage] = useState({
    status: "",
    text: "",
    passwordsError: {
      newPassword: "",
      confirmPassword: "",
    },
  });

  useEffect(() => {
    const getEmail = async () => {
      const { data: response } = await axios
        .get(
          process.env.REACT_APP_BASE_URL +
            APIVariables.USERS_PASSWORD_RESET_GET_EMAIL +
            uid +
            "/" +
            token +
            "/"
        )
        .catch((error) => {
          if (error?.response?.status === 400) {
            setMessage((prev) => ({
              ...prev,
              status: 400,
              text: error?.response?.data?.detail,
            }));
          }
        });

      if (response?.email) {
        setLoginCredentials((prev) => ({
          ...prev,
          email: response?.email,
        }));
      }
    };
    getEmail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isSubmitting) checkInputs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loginCredentials]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLoginCredentials((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const checkInputs = () => {
    const passwordsErrors = {
      newPassword: "",
      confirmPassword: "",
    };
    if (loginCredentials.confirmPassword.length === 0) {
      passwordsErrors.confirmPassword = "required";
    }
    if (loginCredentials.newPassword.length === 0) {
      passwordsErrors.newPassword = "required";
    } else if (
      loginCredentials.newPassword.length < 12 ||
      loginCredentials.newPassword.length > 64 ||
      !validatePassword(loginCredentials.newPassword)
    ) {
      passwordsErrors.newPassword = "sample";
    } else if (
      loginCredentials.newPassword !== loginCredentials.confirmPassword
    ) {
      passwordsErrors.newPassword = "match";
    }

    setMessage((prev) => ({
      ...prev,
      passwordsError: passwordsErrors,
      text: "",
    }));

    return passwordsErrors;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const errors = checkInputs();
    setIsSubmitting(true);
    if (
      errors.newPassword.length === 0 &&
      errors.confirmPassword.length === 0
    ) {
      const { data: responseResetPassword } = await axios
        .post(
          process.env.REACT_APP_BASE_URL +
            APIVariables.USERS_PASSWORD_RESET +
            uid +
            "/" +
            token +
            "/",
          {
            password1: loginCredentials.newPassword,
            password2: loginCredentials.confirmPassword,
          }
        )
        .catch((error) => {
          if (error.response?.data?.password1?.length > 0) {
            setMessage((prev) => ({
              ...prev,
              status: "",
              text: error?.response?.data?.password1[0],
            }));
          }
          return;
        });

      if (responseResetPassword) {
        setMessage((prev) => ({
          ...prev,
          status: responseResetPassword?.message?.includes("Success")
            ? 200
            : "",
          text: responseResetPassword?.message,
        }));
      }
    }
  };

  const redirectToLogin = (event) => {
    event.preventDefault();
    navigate(Auth.LOGIN, { replace: true });
  };

  const shellStyle = { backgroundImage: `url(${loginBackground})` };

  const statusPanelClass =
    "flex min-h-[280px] flex-col items-center justify-center text-center text-white";

  return (
    <div
      className={shellClass}
      style={shellStyle}
      data-testid="auth-reset-validate-page"
    >
      <header className="login-z flex shrink-0 items-center px-6 py-6 sm:px-10">
        <PathfinderLogoLeftCorner
          className="h-[34px] w-auto max-w-[min(100%,186px)] sm:h-[42px]"
          aria-label="PATHFINDER Connect"
          role="img"
        />
      </header>

      <main className="login-z flex flex-1 flex-col items-center justify-center px-4 pb-10 pt-2">
        <div
          className={cardClass}
          style={cardStyle}
          data-testid="auth-reset-validate-card"
        >
          {message.status === 200 ? (
            <div
              className={statusPanelClass}
              data-testid="auth-reset-success"
            >
              <img
                src={CheckRegister}
                alt=""
                className="h-20 w-20"
                aria-hidden
              />
              <h1
                className="mb-4 mt-8 text-2xl font-semibold"
                data-testid="auth-reset-success-heading"
              >
                Password reset
              </h1>
              <p
                className="m-0 text-lg"
                data-testid="auth-reset-success-message"
              >
                Your password has been updated.
              </p>
              <button
                type="button"
                className={greenButtonClass}
                onClick={redirectToLogin}
                data-testid="auth-reset-success-login-button"
              >
                Login
              </button>
            </div>
          ) : message.status === 400 ? (
            <div className={statusPanelClass} data-testid="auth-reset-error">
              <img src={Error} alt="" className="h-20 w-20" aria-hidden />
              <h1
                className="mb-4 mt-8 text-2xl font-semibold text-[#E41818]"
                data-testid="auth-reset-error-heading"
              >
                {message.text}
              </h1>
              <p
                className="m-0 text-lg"
                data-testid="auth-reset-error-description"
              >
                Please click/copy the link again to reset your password.
              </p>
            </div>
          ) : (
            <>
              <p
                className="mb-5 mt-4 text-base leading-relaxed text-white/90"
                data-testid="auth-reset-description"
              >
                {!token
                  ? "Please enter your email address below and we will send you a link to reset your password."
                  : "Please enter and confirm your new password below."}
              </p>

              <form
                className="flex flex-col gap-5"
                onSubmit={onSubmit}
                noValidate
                data-testid="auth-reset-form"
              >
                <div className="flex flex-col gap-2">
                  <label htmlFor="reset-email" className={labelClass}>
                    Email Address
                  </label>
                  <input
                    id="reset-email"
                    type="email"
                    name="email"
                    disabled
                    value={loginCredentials.email}
                    className={inputClass}
                    data-testid="auth-reset-email-input"
                  />
                </div>

                <div className="grid gap-4 sm:grid-cols-2">
                  <div className="flex flex-col gap-2">
                    <label htmlFor="reset-new-password" className={labelClass}>
                      New Password
                    </label>
                    <input
                      id="reset-new-password"
                      type="password"
                      autoComplete="new-password"
                      onChange={handleChange}
                      name="newPassword"
                      data-testid="auth-reset-new-password-input"
                      className={
                        inputClass +
                        (message.passwordsError.newPassword.length > 0
                          ? " ring-amber-300"
                          : "")
                      }
                    />
                  </div>
                  <div className="flex flex-col gap-2">
                    <label
                      htmlFor="reset-confirm-password"
                      className={labelClass}
                    >
                      Confirm Password
                    </label>
                    <input
                      id="reset-confirm-password"
                      type="password"
                      autoComplete="new-password"
                      onChange={handleChange}
                      name="confirmPassword"
                      data-testid="auth-reset-confirm-password-input"
                      className={
                        inputClass +
                        (message.passwordsError.confirmPassword.length > 0
                          ? " ring-amber-300"
                          : "")
                      }
                    />
                    {message.passwordsError.confirmPassword === "required" && (
                      <p
                        className="text-sm text-amber-100"
                        data-testid="auth-reset-confirm-password-error"
                      >
                        Required
                      </p>
                    )}
                  </div>
                </div>

                <div
                  className="space-y-1 text-sm text-amber-100"
                  data-testid="auth-reset-password-errors"
                >
                  {message.passwordsError.newPassword === "required" && (
                    <p>Required</p>
                  )}
                  {message.passwordsError.newPassword === "sample" &&
                    loginCredentials.newPassword.length < 64 && (
                      <>
                        <p>Minimum length of 12 characters</p>
                        <p>Minimum of 1 uppercase letter.</p>
                        <p>At least 1 non-alphanumeric character (~!@#$%)</p>
                        <p>At least 1 number</p>
                      </>
                    )}
                  {message.passwordsError.newPassword === "sample" &&
                    loginCredentials.newPassword.length > 64 && (
                      <p>Ensure this value has at most 64 characters</p>
                    )}
                  {message.passwordsError.newPassword === "match" && (
                    <p>{errorMessages.PASSWORD_NOT_MATCH}</p>
                  )}
                  {message?.text.length > 0 && <p>{message.text}</p>}
                </div>

                <button
                  type="submit"
                  className={primaryButtonClass}
                  data-testid="auth-reset-submit-button"
                >
                  Reset
                </button>
              </form>

              <hr className="my-6 border-0 border-t border-white/30" />
              <a
                href={`${Auth.LOGIN}?register=1`}
                className="flex items-center justify-between gap-3 text-white no-underline transition hover:opacity-90"
                data-testid="auth-reset-register-link"
              >
                <span className="text-lg text-white/90">
                  Register for an account
                </span>
                <ArrowNext className="h-5 w-5 shrink-0" aria-hidden />
              </a>
            </>
          )}
        </div>
      </main>
    </div>
  );
};

export default ResetPassword;
